import { AbstractEditEntityComponent } from '@abstracts/entities/edit-entity';
import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Injector, Input, OnInit } from '@angular/core';
import { ChargingStation } from '@models/charging-station';
import { TransactionDto } from '@dto/transactionDto';
import { UpdateStatusFirmwareRequest } from '@dto/ocpp/UpdateStatusFirmwareRequest';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { UsersService } from '@services/entity/users.service';
import { TransactionsService } from '@services/entity/transactions.service';
import { plainToClass } from 'class-transformer';
import { ToastService } from '@services/toast/toast.service';
import { interval, Subscription } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import { GetConfigurationRequest } from '@dto/ocpp/getConfigurationRequest';
import { ConfigurationRequest } from '@dto/ocpp/configurationRequest';
import { UpdateFirmwareRequest } from '@dto/ocpp/UpdateFirmwareRequest';
import { FilesService } from '@services/files/files.service';
import { ChargingStationNoteDto } from '../../../../dto/chargingStationNote';
import { timestamp } from 'rxjs/operators';
import { UserDto } from '../../../../dto/userDto';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { ChargingStationNote } from '../../../../models/chargingStationNote';
import { DEDatePipe } from '../../../../pipes/de-date.pipe';
import { DEDatePipeShort } from '../../../../pipes/de-date-short.pipe';




@Component({
  selector: 'app-notes-charging-station',
  templateUrl: './notes-charging-station.component.html',
  styleUrls: ['./notes-charging-station.component.scss'],
})


export class NotesChargingStationComponent extends AbstractEditEntityComponent implements OnInit, AfterViewInit {

  public className = 'NotesChargingStationComponent';

  messages: ChargingStationNoteDto[] = [];
  newMessage: string = '';
  
  @Input() entity: ChargingStation;

  public freeChargeStatus: boolean;
  public statusClass: string = '';
  public isOperatorView: boolean;
  public user: UserDto;
  public noteText: string = '';
  public notes: ChargingStationNoteDto[] = [];


  
  constructor(
    private chargingStationsService: ChargingStationsService,
    public authenticationService: AuthenticationService,
    public injector: Injector
  ) {
    super(chargingStationsService, injector);
  }

  ngOnInit() {
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    super.ngOnInit();
    //this.createForm();
  }

  ngAfterViewInit() {
    this.getNotes();
    this.getMessages();
  }

  getNotes() {
    this.chargingStationsService.getNotes(this.entity.id).subscribe(result => {
      this.notes = result
      //console.log(this.notes);
      this.getMessages();
    });
    ;
  }


  createForm() {
    //this.formService.form = new FormGroup({
    //  notes: new FormControl({ value: this.noteText, disabled: true }),
    //  newNote: new FormControl(),
    //})
    //this.formService.formCreated = true;
  }

  getMessages() {
    this.messages = this.notes;

  }

  sendMessage() {
    var author = this.authenticationService.getLoggedInUser().fullName;
    if (this.newMessage.trim()) {

      var note: ChargingStationNoteDto = {
        chargingStationId: this.entity.id,
        author: author,
        content: this.newMessage,
        timestamp: new Date()
      };

      this.chargingStationsService.saveNote(this.primaryKey.toString(), note).subscribe(result => {
        this.messages.push(note);
       this.getNotes();
      })
      this.newMessage = '';
    }
  }

  deleteMessage(index: number) {
    this.chargingStationsService.deleteNote(this.notes[index].id).subscribe(result => {
      //console.log(this.notes[index].id);
        this.getNotes();
    })
  }


  onSubmit(formValue) {
    //var author = this.authenticationService.getLoggedInUser().fullName;
    //console.log(formValue);
    //if (this.formService.form.get('newNote').value != '') {
    //  var note: ChargingStationNoteDto = {
    //    chargingStationId: this.entity.id,
    //    content: formValue.newNote,
    //    author: author,
    //    timestamp: new Date(),

    //  }
    //  this.chargingStationsService.saveNote(this.primaryKey.toString(), note).subscribe( result => {
    //    console.log(result);
    //    this.getNotes();
    //  })
    //} else {
    //  console.log('Fehler');
    //}
  }

  initializeEntity(entity) {
    this.entity = plainToClass(ChargingStation, entity);
  }
}
